import React, {Component} from 'react';
import produce from 'immer';
import withLifecycles from 'async-lifecycles';
import {Table, Icon, Item, Header, Input, Pagination} from 'semantic-ui-react';
import {debounce} from 'lodash';

import {TimeFormat} from '.././components/date';
import auditApi from '../../store/services/audit';
import FormContainer from '../form-components/FormContainer';
import usersImage from '../assets/users.svg';
import styled from 'react-emotion';

const Styles = styled.div`
  .tableHeader {
    background-color: '#f00';
    display: flex;
    flex-grow: 1;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    .ui.header {
      margin-bottom: 0;
    }
  }
`;

class AuditsTable extends Component {
  state = {
    loading: false,
    pageInfo: {},
    searchTerm: '',
  };

  async componentDidMount() {
    this._loadAudits();
  }

  _loadAudits = (pageNumber, searchTerm, showLoading = true) => {
    withLifecycles(
      () =>
        auditApi.fetch({
          request: {
            page: pageNumber,
            pageSize: 20,
          },
          searchTerm: searchTerm,
        }),
      ({loading, data, error}) => {
        this.setState(
          produce(draft => {
            if (showLoading) {
              draft.loading = loading;
            }

            if (data && !data.hasErrors) {
              draft.pageInfo = data.result;
            }
          })
        );
      }
    );
  };

  render() {
    const {pageInfo} = this.state;
    const users = pageInfo.data || [];
    return (
      <FormContainer loading={this.state.loading}>
        <Styles>
          <div className="tableHeader">
            <Header as="h1">Search History</Header>
            <Input
              placeholder="Search History..."
              onChange={debounce((e, searchTerm) => {
                this._loadAudits(0, searchTerm.value, true);
                this.setState({searchTerm: searchTerm.value});
              }, 400)}
            />
          </div>
        </Styles>
        {pageInfo.pageCount === 0 && (
          <Item.Group>
            <Item>
              <Item.Image size="mini" src={usersImage} />
              <Item.Content verticalAlign="middle">
                <strong>No Search History</strong>
                <div>
                  <small>
                    New searches will appear here when users start searching.
                  </small>
                </div>
              </Item.Content>
            </Item>
          </Item.Group>
        )}
        {pageInfo.pageCount > 0 && (
          <React.Fragment>
            <Table basic="very" selectable>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell />
                  <Table.HeaderCell>Searched by</Table.HeaderCell>
                  <Table.HeaderCell>Account Email</Table.HeaderCell>
                  <Table.HeaderCell>Type</Table.HeaderCell>
                  <Table.HeaderCell>Content</Table.HeaderCell>
                  <Table.HeaderCell>Date</Table.HeaderCell>
                </Table.Row>
              </Table.Header>

              <Table.Body>{users.map(this._renderRow)}</Table.Body>
            </Table>

            <Pagination
              defaultActivePage={1}
              onPageChange={async (e, paginationInfo) => {
                await this._loadAudits(
                  paginationInfo.activePage - 1,
                  this.state.searchTerm
                );
              }}
              ellipsisItem={{
                content: <Icon name="ellipsis horizontal" />,
                icon: true,
              }}
              firstItem={{
                content: <Icon name="angle double left" />,
                icon: true,
              }}
              lastItem={{
                content: <Icon name="angle double right" />,
                icon: true,
              }}
              prevItem={{content: <Icon name="angle left" />, icon: true}}
              nextItem={{
                content: <Icon name="angle right" />,
                icon: true,
              }}
              totalPages={pageInfo.pageCount}
            />
          </React.Fragment>
        )}
      </FormContainer>
    );
  }

  _renderRow = audit => (
    <Table.Row key={audit.id}>
      <Table.Cell collapsing></Table.Cell>
      <Table.Cell>{audit.fullName}</Table.Cell>
      <Table.Cell>{audit.emailAddress}</Table.Cell>
      <Table.Cell>{audit.type}</Table.Cell>
      <Table.Cell>
        {audit.identifier}
        {audit.type === 'Serial' && audit.partNumber
          ? ` (Part #${audit.partNumber})`
          : ''}
      </Table.Cell>
      <Table.Cell>
        <TimeFormat date={audit.createdDate}></TimeFormat>
      </Table.Cell>
    </Table.Row>
  );
}

export default AuditsTable;
